import React, {
  FC, useState,
} from 'react';
import PingFangMediumText from '../../../../../components/Text/PingFangMediumText';
import { GreenQuestion } from '../../../../../assets/svg-image/common';
import SquadRegularText from '../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../components/Text/PingFangRegularText';
import SquadSemiBoldText from '../../../../../components/Text/SquadSemiBoldText';
import SquadBoldText from '../../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../../components/Text/PingFangSemiBoldText';
import RowCenter from '../../../../../components/Layout/RowCenter';

const QuestionIcon: FC<Props> = ({
  isEnglish,
  marginLeft,
}) => {
  const [showQuestion, setShowQuestion] = useState<boolean>(false);
  return (
    <div>
      <div
        style={{ marginLeft }}
        onClick={() => setShowQuestion(!showQuestion)}
      >
        <img src={GreenQuestion} style={{ width: 18, height: 18 }} />
      </div>

      {
        showQuestion && (
          <div style={{ position: 'absolute', zIndex: 1 }}>
            <div style={{ width: 23, height: 23, transform: 'rotate(45deg)', backgroundColor: '#F3F3F3' }} />
            <div style={{ width: 238, backgroundColor: '#F3F3F3', paddingTop: 17, paddingBottom: 17, borderRadius: 8, marginLeft: -60, marginTop: -15 }}>
              {
                isEnglish ? (
                  <SquadBoldText fontSize={15} lineHeight={17} textAlign={'center'}>
                    Pricing
                  </SquadBoldText>
                ) : (
                  <PingFangSemiBoldText fontSize={15} lineHeight={20} textAlign={'center'}>
                    价格
                  </PingFangSemiBoldText>
                )
              }
              <RowCenter>
                {
                  isEnglish ? (
                    <SquadRegularText fontSize={15} lineHeight={17} width={208} letterSpacing={1} marginTop={3} textAlign={'center'}>
                      The <SquadSemiBoldText fontSize={15} lineHeight={17} letterSpacing={1} isSpan={true}>first hour is FREE</SquadSemiBoldText> , then it's $1.00 per hour until the daily rate is reached. <SquadSemiBoldText fontSize={15} lineHeight={17} letterSpacing={1} isSpan={true}>The daily rate is $5</SquadSemiBoldText>.
                    </SquadRegularText>
                  ) : (
                    <PingFangRegularText fontSize={15} lineHeight={17} width={208} marginTop={3} textAlign={'center'}>
                      <PingFangMediumText fontSize={15} lineHeight={17} isSpan={true}>第一个小时免费</PingFangMediumText>，之后每小时 $1，直到达到每日费率。<PingFangMediumText fontSize={15} lineHeight={17} isSpan={true}>每日费率为 $5</PingFangMediumText>。
                    </PingFangRegularText>
                  )
                }
              </RowCenter>
            </div>
          </div>
        )
      }
    </div>
  );
};

export interface Props {
  isEnglish: boolean;
  marginLeft?: number;
}

export default QuestionIcon;
